import React from 'react'
import PropTypes from 'prop-types'
import {Tag, TagLabel, TagLeftIcon} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import {SolidWarningIcon, AttentionIconAlert} from '../../../../icons'

const fetchStatusDetails = (status, daysPastDue, t) => {
  switch (status) {
    case 'not_yet_due':
      return [t('invoices.statusLabels.notYetDue'), 'warning']
    case 'overdue':
      return [t('invoices.statusLabels.overdue'), 'alert']
    default:
      if (daysPastDue > 0) {
        return [t('invoices.statusLabels.overdue'), 'alert']
      }

      return [
        t('invoices.statusLabels.dueThisMonth'),
        daysPastDue ? 'success' : 'neutral',
      ]
  }
}

const InvoiceStatusTag = ({status, daysPastDue, displayDaysPastDue}) => {
  const absDaysPastDue = Math.abs(daysPastDue)
  const {t} = useTranslation('payerStatements')

  const [statusLabel, statusColor] = fetchStatusDetails(status, daysPastDue, t)

  return daysPastDue && displayDaysPastDue ? (
    <Tag variant="detail" colorScheme={statusColor}>
      {statusLabel === t('invoices.statusLabels.overdue') ? (
        <TagLabel>
          {t('invoices.drawer.invoiceStatus.overdueWithDays', {
            count: absDaysPastDue,
          })}
        </TagLabel>
      ) : (
        <TagLabel>
          {t('invoices.drawer.invoiceStatus.notYetDueWithDays', {
            count: absDaysPastDue,
          })}
        </TagLabel>
      )}
    </Tag>
  ) : (
    <Tag variant="status" colorScheme={statusColor}>
      {statusLabel === t('invoices.statusLabels.dueThisMonth') && (
        <TagLeftIcon as={SolidWarningIcon} color="mld.warning.700" />
      )}
      {statusLabel === t('invoices.statusLabels.overdue') && (
        <TagLeftIcon as={AttentionIconAlert} color="mld.alert.50" />
      )}
      <TagLabel>{statusLabel}</TagLabel>
    </Tag>
  )
}

InvoiceStatusTag.propTypes = {
  status: PropTypes.string.isRequired,
  daysPastDue: PropTypes.number.isRequired,
  displayDaysPastDue: PropTypes.bool.isRequired,
}

export default InvoiceStatusTag
